import {
  DataModelBuilder, SerializationContext, SerializedData,
} from '../../../../dto/data-model.js';
import { AuditLogEntry } from '../../audit-log-entry.js';
import { OnlineEventTicketOrder } from '../../../online-event-ticket-order.js';
import { MapUtils } from '../../../../../utility/map-utils.js';
import {
  cloneData, isSameData,
} from '../../../../dto/data-model-utils.js';
import { AuditLogEntryType } from '../../audit-log-entry-type.js';

export class OnlineEventTicketOrderCreatedEntry extends AuditLogEntry {
  static readonly TYPE_ID: string = 'e5cce0df91d14aad9de194bad10e6b96';

  private constructor(
      public readonly order: OnlineEventTicketOrder,
  ) {
    super();
  }

  get $typeId(): string {
    return OnlineEventTicketOrderCreatedEntry.TYPE_ID;
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.OnlineEventTicketOrderCreated;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.order.businessRef.encode(),
      eventId: this.order.eventId,
      orderId: this.order.uniqueId,
      customerId: this.order.creatorId,
      isGuestOrder: this.order.isGuestOrder,
    };
  }

  static create(args: {
      order: OnlineEventTicketOrder,
  }): OnlineEventTicketOrderCreatedEntry {
    return new OnlineEventTicketOrderCreatedEntry(
        args.order,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): OnlineEventTicketOrderCreatedEntry {
    return this.create({
      order: context.fromData(MapUtils.getRecord(map, 'order')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      order: context.toData(this.order),
    };
  }

  clone(): this {
    return OnlineEventTicketOrderCreatedEntry.create({
      order: cloneData(this.order),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.order, this.order);
  }
}

export class OnlineEventTicketOrderCreatedEntryBuilder extends DataModelBuilder<OnlineEventTicketOrderCreatedEntry> {
  build(context: SerializationContext, map: SerializedData): OnlineEventTicketOrderCreatedEntry {
    return OnlineEventTicketOrderCreatedEntry.fromMap(context, map);
  }
}
